function findIndex(arr, predicate, fromIndex) {
    if (fromIndex === void 0) { fromIndex = 0; }
    for (var i = fromIndex; i < arr.length; i++) {
        if (predicate(arr[i], i)) {
            // 找到终止循环
            return i;
        }
    }
    return -1;
}
export default findIndex;
//# sourceMappingURL=find-index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/find-index.js
// module id = 468
// module chunks = 3